import { memo } from 'react';
import { Control, FieldPath, FieldValues, useController, useFormContext } from 'react-hook-form';
import { DatesSlider } from './DatesSlider';

type DatesSliderProps = React.ComponentProps<typeof DatesSlider>;

type RHFDatesSliderProps<TFieldValues extends FieldValues = FieldValues> = Omit<
  DatesSliderProps,
  'input'
> & {
  name: FieldPath<TFieldValues>;
  control?: Control<TFieldValues>;
};

const RHFDatesSliderInner = <TFieldValues extends FieldValues = FieldValues>({
  name,
  control: controlProp,
  ...props
}: RHFDatesSliderProps<TFieldValues>) => {
  const formContext = useFormContext<TFieldValues>();
  const control = controlProp ?? formContext?.control;

  const { field } = useController({ name, control });

  return <DatesSlider {...props} input={field} />;
};

export const RHFDatesSlider = memo(RHFDatesSliderInner) as typeof RHFDatesSliderInner;
